// @core/api/endpoints/document/list_numbering_counters.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNumberingCountersResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List counters
 * Returns all active counters for a numbering scheme, showing current values per scope.
 */
export async function ListNumberingCounters(
  scheme_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNumberingCountersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/numbering-schemes/:scheme_id/counters`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.get<ListNumberingCountersResponse>(requestPath, { ...requestOptions, params });
}
